module.exports = __webpack_public_path__ + "static/media/image17.d098fa14.png";